import Card from "../../components/Cards/Card";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import PDF from "../RegrasCamapnha/01_Manual_Programa_de_Excelência_Cargill_1.pdf";

export function RegrasCampanhas() {
  return (
    <div className="app faq">
      <div className="appContent">
        <LayoutWrapper>
          <Card style={{ height: "100%" }}>
            <div className="container-titles">
              <h3>Regras da Campanha</h3>
            </div>
            <iframe
              title="pdf-regras-da-campanha"
              height={"642px"}
              width={"100%"}
              style={{ margin: "auto" }}
              // src="https://www.thecampusqdl.com/uploads/files/01_Manual_Programa_de_Excelência_Cargill_1.pdf"
              src={PDF}
            />
          </Card>
        </LayoutWrapper>
      </div>
    </div>
  );
}
